import { styled } from '@mui/material/styles';
import { Create } from 'react-admin';
import { Box } from 'shared/mui/Box';

export const CreateStyled = styled(Create)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  backgroundColor: theme.palette.background.default,
  padding: '24px',
  '& .MuiCardContent-root': {
    padding: 0,
  },
  '& .MuiCardContent-root:last-child': {
    padding: 0,
  },
  '& .RaCreate-main': {
    margin: 0,
  },
}));

export const BoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '24px',
});
